// src/label/src/hint.tsx
import { cx } from "class-variance-authority";
import { jsx } from "react/jsx-runtime";
var HintComponent = ({
  disabled = false,
  hintId,
  hint
}) => /* @__PURE__ */ jsx(
  "span",
  {
    className: cx("text-xs", {
      "text-interactive-disabled": disabled,
      "text-surface-body": !disabled
    }),
    id: hintId,
    children: hint
  }
);

export {
  HintComponent
};
